export let Facilities = /*#__PURE__*/function (Facilities) {
  Facilities["Cycleways"] = "cycleways";
  Facilities["Greenways"] = "greenways";
  Facilities["Lanes"] = "lanes";
  Facilities["Opposites"] = "opposites";
  Facilities["SharedBusways"] = "sharedBusways";
  Facilities["MixedFacilities"] = "mixedfacilities";
  return Facilities;
}({});
export let ParkingTypes = /*#__PURE__*/function (ParkingTypes) {
  ParkingTypes["Arch"] = "arch";
  ParkingTypes["Free"] = "free";
  ParkingTypes["Locked"] = "locked";
  ParkingTypes["Private"] = "private";
  ParkingTypes["Rack"] = "rack";
  ParkingTypes["Secure"] = "secure";
  ParkingTypes["Sheltered"] = "sheltered";
  return ParkingTypes;
}({});

// The BNSC data has no counterpart for locked shelters, so they are excluded
// from every zone statistic.

export const parkingStatsTypes = [ParkingTypes.Arch, ParkingTypes.Free, ParkingTypes.Private, ParkingTypes.Rack, ParkingTypes.Secure, ParkingTypes.Sheltered];
export let ParkingFurnitureTypes = /*#__PURE__*/function (ParkingFurnitureTypes) {
  ParkingFurnitureTypes["Arch"] = "arch";
  ParkingFurnitureTypes["BigArch"] = "bigArch";
  ParkingFurnitureTypes["DoubleDeckerRack"] = "doubleDeckerRack";
  ParkingFurnitureTypes["Rack"] = "rack";
  ParkingFurnitureTypes["HandlebarSupport"] = "handlebarSupport";
  ParkingFurnitureTypes["Hook"] = "hook";
  ParkingFurnitureTypes["Bollard"] = "bollard";
  ParkingFurnitureTypes["NoEquipment"] = "noEquipment";
  ParkingFurnitureTypes["Other"] = "other";
  return ParkingFurnitureTypes;
}({});
export class CyclabilityZoneStats {
  constructor(date, distances) {
    this.date = date;
    this.distances = distances;
    this.dateAsKey = toDateKey(date);
  }
}
export class CyclabilityZoneBNSCStats {
  constructor(date, slots, furniture = {
    [ParkingFurnitureTypes.Arch]: 0,
    [ParkingFurnitureTypes.BigArch]: 0,
    [ParkingFurnitureTypes.DoubleDeckerRack]: 0,
    [ParkingFurnitureTypes.Rack]: 0,
    [ParkingFurnitureTypes.HandlebarSupport]: 0,
    [ParkingFurnitureTypes.Hook]: 0,
    [ParkingFurnitureTypes.Bollard]: 0,
    [ParkingFurnitureTypes.NoEquipment]: 0,
    [ParkingFurnitureTypes.Other]: 0
  }) {
    this.date = date;
    this.slots = slots;
    this.furniture = furniture;
    this.dateAsKey = toDateKey(date);
  }
}
export function toDateKey(date) {
  return date.format('YYYY-MM');
}